import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Owns navbar toggle state (mobile drawer, desktop dropdown, mobile accordion); resets on navigation. */
export default function useNavbarState() {
  const [open, setOpen] = useState(false);
  const [openKey, setOpenKey] = useState(null);
  const [mobileKey, setMobileKey] = useState(null);
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    setOpen(false);
    setOpenKey(null);
    setMobileKey(null);
  }, [pathname, hash, search]);

  return {
    open,
    toggleOpen: () => setOpen((v) => !v),
    openKey,
    setOpenKey,
    mobileKey,
    toggleMobileKey: (key) => setMobileKey((k) => (k === key ? null : key)),
  };
}
